import React from 'react';
import AutomationRulesPage from '../AutomationRulesPage';
import TrainerLayout from '../../components/layout/TrainerLayout';

const TrainerAutomationPage = () => (
  <AutomationRulesPage LayoutComponent={TrainerLayout} clientsEndpoint="/trainer/clients" />
);

export default TrainerAutomationPage;
